export const validateEmail = (value: string) => {
  const regex = new RegExp('^[a-zA-Z0-9+-_.]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$');
  return regex.test(value);
};
